<template>
    <fade-left-animation :element="() => $refs.section">
        <section class="products-carousel-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div
                        class="header"
                        :class="{
                            'has-button': buttonText && buttonLink,
                        }"
                    >
                        <h2 class="heading h1">{{ title }}</h2>

                        <!-- desktop button -->
                        <b-button
                            v-if="buttonText && buttonLink"
                            variant="primary"
                            class="menu-btn desktop-btn"
                            :to="buttonLink"
                            v-test:button
                        >
                            {{ buttonText }}
                        </b-button>
                    </div>

                    <base-carousel
                        navigation
                        :always-show-navigation="showNavigationButtons"
                        :breakpoints="breakpoints"
                    >
                        <product-listing-card
                            v-for="(slide, i) in slides"
                            :key="slide.name"
                            v-bind="slide"
                            :slot="`slide_${ slide.name }_${ i }`"
                        />
                    </base-carousel>

                    <!-- mobile button -->
                    <div v-if="buttonText && buttonLink" class="btn-container">
                        <b-button
                            variant="primary"
                            class="menu-btn mobile-btn"
                            :to="buttonLink"
                            v-test:button
                        >
                            {{ buttonText }}
                        </b-button>
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-left-animation>
</template>

<script>
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';
    import ProductListingCard from '../../molecules/ProductListingCard/ProductListingCard';

    export default {
        name: 'products-carousel-section',

        components: { ProductListingCard, BaseCarousel },

        props: {
            title: {
                type: String,
                required: true,
            },

            buttonText: {
                type: String,
                default: '',
            },

            buttonLink: {
                type: String,
                default: '',
            },

            slides: {
                type: Array,
                default: () => ([]),
            },

            showNavigationButtons: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * If there is only 1 slide in the carousel, ensure on mobile it takes up full width.
             *
             * @returns {object}
             */
            breakpoints() {
                if (this.slides.length !== 1) {
                    return {};
                }

                return {
                    0: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 2,
                    },
                    960: {
                        slidesPerView: 3,
                    },
                    1344: {
                        slidesPerView: 4,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .products-carousel-section {
        position: relative;
        padding-top: 45px;
        padding-bottom: 45px;
        overflow-x: hidden;

        @include media-breakpoint-up(md) {
            padding-top: 64px;
            padding-bottom: 64px;
        }
    }

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        justify-content: center;

        @include media-breakpoint-up(md) {
            justify-content: space-between;
        }

        .has-button {
            @include media-breakpoint-up(md) {
                margin-bottom: 0;
            }
        }
    }

    .heading {
        text-align: center;
        margin: 0;

        @include media-breakpoint-up(md) {
            text-align: left;
        }
    }

    .desktop-btn {
        display: none;

        @include media-breakpoint-up(md) {
            display: block;
        }
    }

    .btn-container {
        text-align: center;
        margin-top: 25px;

        @include media-breakpoint-up(md) {
            display: none;
        }
    }
</style>
